import type { RouteLocationRaw } from "vue-router";
import { Roles } from "@/constants/Roles";
import {
  ROUTE_DASHBOARD,
  ROUTE_OPERATIONS_MINE_DEPOSITS,
} from "@/constants/RouteNames";

export const resolveDefaultAuthenticatedRoute = (
  userRole?: Roles | null
): RouteLocationRaw => {
  switch (userRole) {
    case Roles.Provider:
      return { name: ROUTE_OPERATIONS_MINE_DEPOSITS };
    case Roles.Admin:
      return { name: ROUTE_DASHBOARD };
    default:
      return { name: ROUTE_DASHBOARD };
  }
};
